<template>
  <modal height="440px" title="App Distribution" ref="modal" :busy="busy">
    <template #top>
      <template v-if="!!apps">
        <b-select v-model="selected" :options="apps.map((f,idx) => ({text: f.app, value: idx}))"/>
      </template>
    </template>

    <template v-if="!!app">
      <modal-row label="Deployed" v-if="app.bundle_file">
        <div>{{ app.bundle_file.created_datetime | date }}</div>
        <div>By {{ app.bundle_file.createdby_user ? app.bundle_file.createdby_user.name + ' (' + app.bundle_file.createdby_user.userid + ')': '??'}}</div>
      </modal-row>
      <modal-row label="Bundle Version">
        <b-check v-model="increment" switch>Auto Increment Version</b-check>
        <b-form-input :disabled="increment" v-model="app.bundle_version"/>
      </modal-row>
      <modal-row label="Bundle Package">
        <div v-if="app.bundle_file">
          <b-link :href="app.bundle_file._links.external_url.href">{{ app.bundle_file.gli }}</b-link>
        </div>
        <div v-else class="text-muted">None yet</div>
        <div class="my-2">
          <file-upload class="btn btn-primary btn-sm mt-3"
                       ref="bundle"
                       v-model="bundles"
                       @input-file="$refs.bundle.active = true"
                       :custom-action="bundleUpload"
                       :multiple="false"
                       input-id="fbundle"
          >Distribute New Bundle
          </file-upload>
        </div>
      </modal-row>
      <form-divider/>
      <modal-row label="Deployed" v-if="app.apk_file">
        <div>{{ app.apk_file.created_datetime | date}}</div>
        <div>By {{ app.apk_file.createdby_user ? app.apk_file.createdby_user.name + ' (' + app.apk_file.createdby_user.userid + ')': '??'}}</div>
      </modal-row>
      <modal-row label="Android Package" is-text>{{ app.package }}</modal-row>
      <modal-row label="Version" is-text>{{ app.apk_version }}</modal-row>
      <modal-row label="Build" is-text>{{ app.apk_build }}</modal-row>
      <modal-row label="APK">
        <div v-if="app.apk_file">
          <b-link :href="app.apk_file._links.external_url.href">{{ app.apk_file.gli }}</b-link>
        </div>
        <div v-else class="text-muted">None yet</div>
        <div class="my-2">
          <file-upload class="btn btn-primary btn-sm mt-3"
                       ref="apk"
                       input-id="fapk"
                       v-model="apks"
                       @input-file="$refs.apk.active = true"
                       :custom-action="apkUpload"
                       :multiple="false"
          >Distribute New APK
          </file-upload>
        </div>
      </modal-row>
    </template>

    <template #footer v-if="false">
      <b-button variant="outline-danger" size="sm" @click="deleteLoc" class="px-4">Delete</b-button>
      <b-button variant="primary" size="sm" class="px-4" @click="save">Update</b-button>
    </template>
  </modal>
</template>

<script>
import {directUpload} from '@/lib/direct-upload'

export default {
  name: "app-distribute",

  props: {
    url: String
  },

  components: {
    fileUpload: () => import('vue-upload-component'),
  },

  data() {
    return {
      apps: null,
      selected: 0,
      increment: true,
      bundles: [],
      apks: [],
      busy: false
    }
  },

  mounted() {
    this.refresh()
  },

  methods: {
    async refresh() {
      this.apps = await this.asyncAction('/api/app', 'GET');
    },
    // straight to storage (an APK outgrows a request), then the stored file to the app by id
    apkUpload(file, component) {
      const url = this.app._links.apk_upload_url.href
      return directUpload(url, made => this.asyncAction(url, 'POST', {noload: true, toast: true, data: {file: made.id}}))(file, component)
    },
    bundleUpload(file, component) {
      const url = this.app._links.bundle_upload_url.href
      return directUpload(url, made => this.asyncAction(url, 'POST', {
        noload: true,
        toast: true,
        data: {file: made.id, increment: this.increment ? 1 : 0, version: this.app.bundle_version},
      }))(file, component)
    },
    processed(uploads, what) {
      uploads.forEach(u => {

        if (u.active)
          this.busy = true
        if (u.success) {
          this.toast('New ' + what + ' uploaded')
          this.$refs[what].remove(u)
          this.refresh()
          this.busy = false
        } else if (u.error) {
          if (u.response && u.response.message)
            this.alert('File ' + u.name + ' failed to upload. ' + u.response.message, false)
          else
            this.alert('File ' + u.name + ' failed to upload.', false)

          this.busy = false
          this.$refs[what].remove(u)
        }
      })
    },
  },

  computed: {
    app() {
      if (!this.apps)
        return null

      return this.apps[this.selected]
    }
  },

  watch: {
    bundles(v) {
      this.processed(v, 'bundle')
    },
    apks(v) {
      this.processed(v, 'apk')
    }
  }

}
</script>


<style scoped>

</style>